/**
 * ENV
 */

// APP_ENV関連の定義はapi-configからインポート・再エクスポート
import { APP_ENV, IS_PRODUCTION, IS_STAGING } from '~/lib/api-config'
export { APP_ENV, IS_PRODUCTION, IS_STAGING }

/**
 * CONSTANTS
 */

const isProdLike = IS_PRODUCTION || IS_STAGING

export const FIREBASE_CONFIG = isProdLike
  ? {
      // for production or staging
      fcmWebPushKey: 'BKSKzZwAJCecdF1ST1-YSASnb1ICxrvpGPLp2fAi-sh8URRbU1kXTWbiAbh_LASCQyU8gKgBuIk4opvL0qBE4Z4',
      apiKey: 'AIzaSyBHf626sYUg5kNMgPPtwUdGG8837bCfin4',
      authDomain: 'collabomarketing-e8d43.firebaseapp.com',
      databaseURL: 'https://collabomarketing-e8d43.firebaseio.com',
      projectId: 'collabomarketing-e8d43',
      storageBucket: 'collabomarketing-e8d43.appspot.com',
      messagingSenderId: '1037612981487',
      appId: '1:1037612981487:web:a10e292a9420dcbb56cf1a',
      measurementId: 'G-BKW1LDMTMM',
    }
  : {
      // for development
      fcmWebPushKey: 'BG8-ZrvNodSoeaBjIiESKCiwub_QmVJL78u9FUT-Hqf0oSMC2al91_EJ8MZm5qf4e7DWJgRccv3ifCj7ySlpddQ',
      apiKey: 'AIzaSyBEzBhALRmUfmn6W7oX0wXqfthNjPG7V_o',
      authDomain: 'collabomarketing-dev.firebaseapp.com',
      databaseURL: 'https://collabomarketing-dev.firebaseio.com',
      projectId: 'collabomarketing-dev',
      storageBucket: 'collabomarketing-dev.appspot.com',
      messagingSenderId: '934949486805',
      appId: '1:934949486805:web:d50e58a7d9981594b1625c',
      measurementId: 'G-GFYS231NZV',
    }

export const APP_ID = isProdLike ? 'jp.co.collabomarketing' : 'jp.co.collabomarketing.dev'

export const APPLE_APP_ID = `UQ4TAGTYU3.${APP_ID}`

export const ZENDESK_KEY = 'cd579bff-60ea-45f9-b859-19503461af2c'

export const PAY_JP_KEY = isProdLike ? 'pk_live_117f4c673779d06fa762bd29' : 'pk_test_e574dfa7cce0adfef1a144a6'

export const CUSTOM_SCHEME = isProdLike ? 'toridorimarketing://' : 'dtoridorimarketing://'

export const TAG_MANAGER_ID = isProdLike ? 'GTM-PLGGDKV' : 'GTM-KGGH8SD'

export const GOOGLE_ANALYTICS_ID = isProdLike ? 'G-BKW1LDMTMM' : 'G-GFYS231NZV'

export const ANDROID_CERTIFICATE_SHA256 = isProdLike
  ? [
      'f4:3c:41:13:2a:51:d6:ac:53:57:20:52:fb:a2:be:cc:86:83:a4:e9:85:34:bf:2c:19:89:64:41:a5:0d:bd:b3',
      '20:62:8D:B3:54:BC:B6:09:56:05:D0:14:41:1A:F6:07:D1:B1:00:8E:21:D0:54:0F:DB:AF:36:8D:1E:EC:C4:8A',
    ]
  : ['A8:98:7E:53:1F:4A:0A:E9:FF:59:AD:71:55:3A:41:51:ED:F4:95:CE:FC:43:B9:FF:4C:F6:B3:DA:EE:F0:58:76']

export const BUGSNAG_API_KEY = 'f8a6a891caf68c5aed709314f3f82216'

// QA は画像CDNを dev と共用するため qa 専用分岐は持たず、image.xdev を流用する（isProdLike=false 側）。
export const IMAGE_HOST = isProdLike ? 'https://image.collatech.net' : 'https://image.xdev.toridori.me'
export const APPLE_REDIRECT_URL = isProdLike ? 'jp.co.collabomarketing' : 'jp.co.collabomarketing.dev'

export const MUI_LICENSE_KEY =
  'a84e46e9fe720d20de320d37245f1119Tz0xMTk4MjIsRT0xNzkwODk5MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='

// ローカルは下記のキーを使用する。.env.localに記載してください。（NEXT_PUBLIC_GOOGLE_MAPS_EMBED_API_KEY="〇〇"）
// https://console.cloud.google.com/apis/credentials/key/fd7028de-f1e5-456f-8907-9c7bec8c568f?hl=ja&inv=1&invt=AbxysQ&project=collabomarketing-dev
export const GOOGLE_MAPS_EMBED_API_KEY = 'AIzaSyD7dM65VAnFJsm_dRRzYGEehe9uWJzPcZs'

export const FACEBOOK_APP_ID = isProdLike ? '623453755804288' : '1085230129048706'

export const CLARITY_ID = isProdLike ? 'bizkqytwo4' : 'du3xksexh5'

export const LINE_OFFICIAL_ACCOUNT_LINK = isProdLike ? 'https://lin.ee/l7yMQhh' : 'https://lin.ee/mHMBaUP'
